import axios from "../../utils/axiosConfig";
 
axios.defaults.withCredentials = true;

const getQuickReports = async (pharmacyId: any,  month: any, year: any) => {

  const { data } = await axios.get( `/api/pharmacy/pharmacyProfile/get/monthly/report?pharmacy_id=${pharmacyId}&month=${month}&year=${year}`);
  return data;
};

const QuickReportsService = {
    getQuickReports,

};

export default QuickReportsService;
